"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphTwoContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const PublicPrivacyNoticeModalContentUtil_1 = require("../informationmodalcontents/PublicPrivacyNoticeModalContentUtil");
const PublicPrivacyNoticeArrowListItems_1 = require("../PublicPrivacyNoticeArrowListItems");
const ParagraphTwoContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    const categories = [
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.main.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.BASIC_INFO
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.content.of.communication'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.MESSAGE
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.children.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.KIDS
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.traffic.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.COMMUNICATION
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.communication.with.telia'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.COMMUNICATION_WITH_TELIA
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.non.personal.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.NON_PERSONAL
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.location.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.LOCATION
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.special.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.PERSONAL_DATA
        },
        {
            heading: translate('gdpr.privacy.notification.paragraph.two.anonymous.data'),
            modalType: PublicPrivacyNoticeModalContentUtil_1.PrivacyNoticeModalType.ANONYMOUS
        }
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.two.text')),
        react_1.default.createElement(lib_1.Grid, { className: "text__margin-double", verticalGutter: "none" },
            react_1.default.createElement(lib_1.GridColumn, { width: ['sm-4'] },
                react_1.default.createElement(lib_1.ArrowList, { bordered: true, outerBordered: true, buttonSize: "default" },
                    react_1.default.createElement(PublicPrivacyNoticeArrowListItems_1.PublicPrivacyNoticeArrowListItems, { categories: categories.slice(0, 3) }))),
            react_1.default.createElement(lib_1.GridColumn, { width: ['sm-4'] },
                react_1.default.createElement(lib_1.ArrowList, { bordered: true, outerBordered: true, buttonSize: "default" },
                    react_1.default.createElement(PublicPrivacyNoticeArrowListItems_1.PublicPrivacyNoticeArrowListItems, { categories: categories.slice(3, 6) }))),
            react_1.default.createElement(lib_1.GridColumn, { width: ['sm-4'] },
                react_1.default.createElement(lib_1.ArrowList, { bordered: true, outerBordered: true, buttonSize: "default" },
                    react_1.default.createElement(PublicPrivacyNoticeArrowListItems_1.PublicPrivacyNoticeArrowListItems, { categories: categories.slice(6, 9) }))))));
};
exports.ParagraphTwoContent = ParagraphTwoContent;
